import React from "react";

const About = ({ content }) => {
  return (
    <section id="about" className="py-16 px-8 text-center">
      <h3 className="text-3xl font-bold mb-6 text-red-500">About Us</h3>
      <p className="text-gray-700 max-w-2xl mx-auto">{content}</p>
    </section>
  );
};

export default About;
